import styled from "styled-components";

const ButtonStyled = styled.section`
    button:not(:last-child){
        margin-right: 0.5rem;
    }
`;

export default ButtonStyled;
